<template>
  <div class="fixed inset-0 z-60">
    <SiteMenuFlyoutLayout :heading="heading" @close="$emit('close')">
      <ul class="space-y-4">
        <li v-for="(item, itemKey) in items" :key="itemKey">
          <button
            v-if="item.menu"
            class="flex justify-between items-center gap-x-4 w-full rounded-lg px-7 py-2.5 text-left focus:outline-none"
            :style="{ backgroundColor: item.menu.backgroundColour }"
            @click="openMenu(itemKey)"
          >
            <div class="flex-shrink w-60">
              <h3 class="text-lg">{{ item.menu.heading }}</h3>
              <p v-if="item.menu.description" class="mt-2 text-sm">
                {{ item.menu.description }}
              </p>
            </div>

            <div class="flex-shrink-0 w-3"><IconArrowRightShort /></div>
          </button>

          <div v-else-if="item.ctas.length" class="space-y-4">
            <div v-for="(cta, ctaKey) in item.ctas" :key="ctaKey">
              <div
                :key="itemKey"
                class="min-h-68 bg-white rounded-lg p-7 relative z-10 overflow-hidden"
                :style="{
                  backgroundColor: cta.backgroundColour,
                  color: cta.textColour,
                }"
              >
                <div class="w-60 max-w-full space-y-5">
                  <h4 class="text-lg font-semibold">
                    {{ cta.heading }}
                  </h4>
                  <p v-if="cta.text" class="text-sm">
                    {{ cta.text }}
                  </p>
                  <a
                    class="btn-soft"
                    :class="{
                      'btn-soft--alt': cta.textColour === 'white',
                    }"
                    :href="cta.button.url"
                    :target="cta.button.target"
                  >
                    {{ cta.button.text }}
                  </a>
                </div>

                <div
                  v-if="cta.backgroundImage.length"
                  class="w-full h-auto absolute left-0 -z-10"
                  :class="{
                    'top-0': cta.backgroundImagePosition === 'top',
                    'bottom-0': cta.backgroundImagePosition === 'bottom',
                  }"
                >
                  <InlineSvg
                    v-if="cta.backgroundImage[0].extension === 'svg'"
                    class="w-full h-auto"
                    :src="cta.backgroundImage[0].url"
                    :transform-source="removeSvgFill"
                    :fill="cta.backgroundImageColour"
                  />
                  <img
                    v-else
                    :src="cta.backgroundImage[0].url"
                    class="w-full h-auto"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </SiteMenuFlyoutLayout>

    <transition v-for="(item, itemKey) in menuItems" :key="itemKey" name="fade">
      <SiteMenuFlyoutMegaPrimarySub
        v-if="isOpenedMenu(itemKey)"
        :heading="item.menu.heading"
        :items-background-colour="item.menu.backgroundColour"
        :items="item.menu.items"
        :cta="lastCta"
        @close="closeMenu"
      />
    </transition>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import SiteMenuFlyoutMixin from "./SiteMenuFlyoutMixin.vue";
import SiteMenuFlyoutMegaPrimarySub from "./SiteMenuFlyoutMegaPrimarySub.vue";
import IconArrowRightShort from "../../../templates/_includes/svg/icon-arrow-right-short.svg";
import { removeSvgFill } from "../../js/utils";

export default {
  name: "SiteMenuFlyoutMegaPrimary",

  components: {
    InlineSvg,
    SiteMenuFlyoutMegaPrimarySub,
    IconArrowRightShort,
  },

  mixins: [SiteMenuFlyoutMixin],

  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: null,
    },
    ctas: {
      type: Array,
      default: null,
    },
  },

  computed: {
    menuItems() {
      return this.items.filter((item) => !!item.menu);
    },
    lastCta() {
      const ctas = this.items.reduce((acc, item) => {
        if (!item.ctas.length) return acc;

        item.ctas.forEach((cta) => acc.push(cta));
        return acc;
      }, []);

      if (!ctas.length) return null;
      return ctas.pop();
    },
  },

  methods: {
    removeSvgFill,
  },
};
</script>
